import { createStore } from 'satcheljs';
var initialSharedCalendarsOptionViewState = {
    calendars: [],
    initialState: {},
    currentState: {},
};
export default createStore('SharedCalendars', initialSharedCalendarsOptionViewState);
//# sourceMappingURL=store.js.map